"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const useAsyncQueuer = require("./useAsyncQueuer.cjs");
function useAsyncQueuedState(fn, options = {}, selector) {
  const asyncQueuer = useAsyncQueuer.useAsyncQueuer(fn, options, selector);
  return [asyncQueuer.state.items, asyncQueuer];
}
exports.useAsyncQueuedState = useAsyncQueuedState;
//# sourceMappingURL=useAsyncQueuedState.cjs.map
